import { createContext, useContext, useCallback } from 'react';

// Single-market product: NYSE + NASDAQ (US equities, USD). The exchange
// context is preserved as a stable hook so every page that destructures
// `useExchange()` keeps working without churn.
const NYSE_CONFIG = {
  id: 'NYSE',
  label: 'NYSE + NASDAQ',
  fullName: 'US Stocks (NYSE + NASDAQ)',
  currency: 'USD',
  currencySymbol: '$',
  flag: '🇺🇸',
  indices: [
    { ticker: 'SPY', name: 'S&P 500' },
    { ticker: 'QQQ', name: 'NASDAQ 100' },
    { ticker: 'IWM', name: 'Russell 2000' },
    { ticker: 'DIA', name: 'Dow Jones' },
  ],
  timezone: 'America/New_York',
  tradingHours: '9:30 AM – 4:00 PM ET',
};

export const EXCHANGES = { NYSE: NYSE_CONFIG };

const ExchangeContext = createContext(null);

export function ExchangeProvider({ children }) {
  const formatCurrency = useCallback((value) => {
    if (typeof value !== 'number' || isNaN(value)) return `$0.00`;
    return `$${value.toFixed(2)}`;
  }, []);

  // No-op kept for source compatibility with old callers.
  const switchExchange = useCallback(() => {}, []);
  const formatTicker = useCallback((ticker) => ticker || '', []);

  return (
    <ExchangeContext.Provider value={{
      exchange: 'NYSE',
      config:   NYSE_CONFIG,
      switchExchange,
      formatTicker,
      formatCurrency,
      isNYSE: true,
    }}>
      {children}
    </ExchangeContext.Provider>
  );
}

export function useExchange() {
  const ctx = useContext(ExchangeContext);
  if (!ctx) throw new Error('useExchange must be used within ExchangeProvider');
  return ctx;
}

export default ExchangeContext;
